// Generated file : do not modify

import { type RouteRecordRaw } from 'vue-router';
import { Modules } from '@/generated/classes/AppSchema';
import FicheContainer from '@/framework/base/components/FicheContainer.vue';
import ModuleAbonnement from '@/extend/modules/ModuleAbonnementExtend.vue';
import ModuleAdmin from '@/framework/admin/components/ModuleAdmin.vue';
import ModuleCart from '@/extend/modules/ModuleCartExtend.vue';
import ModuleCompta from '@/extend/modules/ModuleComptaExtend.vue';
import ModuleDocument from '@/extend/modules/ModuleDocumentExtend.vue';
import ModuleMarketing from '@/extend/modules/ModuleMarketingExtend.vue';
import ModuleNotification from '@/custom/modules/ModuleNotification.vue';
import ModulePreference from '@/extend/modules/ModulePreferenceExtend.vue';
import ModuleProfil from '@/extend/modules/ModuleProfilExtend.vue';
import ModuleProjet from '@/extend/modules/ModuleProjetExtend.vue';
import ModuleSalarie from '@/extend/modules/ModuleSalarieExtend.vue';
import ModuleEtablissement from '@/extend/modules/ModuleEtablissementExtend.vue';
import ModuleSupport from '@/extend/modules/ModuleSupportExtend.vue';

export const Routes: RouteRecordRaw[] = [
  {
    path: '/:type/:id',
    name: 'FicheContainer',
    component: FicheContainer,
    props: true
  },
  {
    path: '/' + Modules.ABONNEMENT.toLowerCase() + '/:id?',
    name: Modules.ABONNEMENT.toLowerCase(),
    component: ModuleAbonnement,
    meta: { transition: 'maximise' },
    props: true
  },
  {
    path: '/' + Modules.ADMIN.toLowerCase() + '/:id?',
    name: Modules.ADMIN.toLowerCase(),
    component: ModuleAdmin,
    meta: { transition: 'maximise' },
    props: true
  },
  {
    path: '/' + Modules.CART.toLowerCase() + '/:id?',
    name: Modules.CART.toLowerCase(),
    component: ModuleCart,
    meta: { transition: 'maximise' },
    props: true
  },
  {
    path: '/' + Modules.COMPTA.toLowerCase() + '/:id?',
    name: Modules.COMPTA.toLowerCase(),
    component: ModuleCompta,
    meta: { transition: 'maximise' },
    props: true
  },
  {
    path: '/' + Modules.DOCUMENT.toLowerCase() + '/:id?',
    name: Modules.DOCUMENT.toLowerCase(),
    component: ModuleDocument,
    meta: { transition: 'maximise' },
    props: true
  },
  {
    path: '/' + Modules.MARKETING.toLowerCase() + '/:id?',
    name: Modules.MARKETING.toLowerCase(),
    component: ModuleMarketing,
    meta: { transition: 'maximise' },
    props: true
  },
  {
    path: '/' + Modules.NOTIFICATION.toLowerCase() + '/:id?',
    name: Modules.NOTIFICATION.toLowerCase(),
    component: ModuleNotification,
    meta: { transition: 'maximise' },
    props: true
  },
  {
    path: '/' + Modules.PREFERENCE.toLowerCase() + '/:id?',
    name: Modules.PREFERENCE.toLowerCase(),
    component: ModulePreference,
    meta: { transition: 'maximise' },
    props: true
  },
  {
    path: '/' + Modules.PROFIL.toLowerCase() + '/:id?',
    name: Modules.PROFIL.toLowerCase(),
    component: ModuleProfil,
    meta: { transition: 'maximise' },
    props: true
  },
  {
    path: '/' + Modules.PROJET.toLowerCase() + '/:id?',
    name: Modules.PROJET.toLowerCase(),
    component: ModuleProjet,
    meta: { transition: 'maximise' },
    props: true
  },
  {
    path: '/' + Modules.SALARIE.toLowerCase() + '/:id?',
    name: Modules.SALARIE.toLowerCase(),
    component: ModuleSalarie,
    meta: { transition: 'maximise' },
    props: true
  },
  {
    path: '/' + Modules.ETABLISSEMENT.toLowerCase() + '/:id?',
    name: Modules.ETABLISSEMENT.toLowerCase(),
    component: ModuleEtablissement,
    meta: { transition: 'maximise' },
    props: true
  },
  {
    path: '/' + Modules.SUPPORT.toLowerCase() + '/:id?',
    name: Modules.SUPPORT.toLowerCase(),
    component: ModuleSupport,
    meta: { transition: 'maximise' },
    props: true
  },
];
